import { Box, Typography, useTheme } from '@mui/material'
import _ from 'lodash'

export const TaskVelocityTooltip = ({ active, payload, label }) => {
  const theme = useTheme()
  if (!active || !payload?.length) return null
  const completed = payload.find(p => p.dataKey === 'completedTasks')?.value ?? 0
  const remaining = payload.find(p => p.dataKey === 'remaining')?.value ?? 0
  const total = completed + remaining
  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        px: 1,
        py: 0.5,
        lineHeight: 1.6,
        boxShadow: theme.shadows[2],
      }}
    >
      <Typography variant="caption" sx={{ fontWeight: 600, display: 'block' }}>{label}</Typography>
      <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block' }}>
        Total: {total}
      </Typography>
      {completed > 0 && (
        <Typography variant="caption" sx={{ color: 'success.main', display: 'block' }}>
          Completed: {completed}
        </Typography>
      )}
    </Box>
  )
}
